import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'

import AuthRoutes from '@/modules/auth/routes'
import ContactRoutes from '@/modules/contact/routes'
import CartRoutes from '@/modules/cart/routes'
import CheckoutRoutes from '@/modules/checkout/routes'
import HomeRoutes from '@/modules/home/routes'
import ProductRoutes from '@/modules/product/routes'
import ProfileRoutes from '@/modules/profile/routes'
import SupplierRoutes from '@/modules/supplier/routes'
import SourcingRoutes from '@/modules/sourcing/routes'
import CategorySearch from '@/modules/product/views/CategorySearch'

Vue.use(VueRouter)

const routes = [
  ...AuthRoutes,
  ...CartRoutes,
  ...CheckoutRoutes,
  ...HomeRoutes,
  ...ProductRoutes,
  ...ProfileRoutes,
  ...SupplierRoutes,
  ...ContactRoutes,
  ...SourcingRoutes,
  {
    path: '/:category',
    name: 'Category',
    component: CategorySearch
  },
  {
    path: '*',
    redirect: to => {
      return { name: 'NotFound', query: to.query }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  if (store.getters.isUserLoggedIn && to.query.prev) {
    next({name: to.query.prev, query: null})
  } else { next() }
})

router.afterEach((to) => {
  document.title = to.meta.title || 'eCommerce: Self Service Sourcing'
})


export default router
